import { getWebchatToken, webchatMediaDownload } from "../api/webchat";

/** File name from a media URL path, ignoring query/hash. */
export function filenameFromMediaUrl(url, fallback = "arquivo") {
  const href = String(url || "").trim();
  if (!href) return fallback;
  try {
    const path = new URL(href, "https://xpro.me").pathname;
    const last = decodeURIComponent(path.split("/").filter(Boolean).pop() || "");
    if (last && /\.[a-z0-9]{2,8}$/i.test(last)) return last.slice(0, 180);
  } catch {
    /* ignore */
  }
  return fallback;
}

function triggerNavigationDownload(href, name) {
  const a = document.createElement("a");
  a.href = href;
  a.download = name || "";
  a.rel = "noopener";
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

async function resolveSignedDownloadUrl(url, filename) {
  if (!getWebchatToken()) return "";
  try {
    const signed = await webchatMediaDownload({ url, filename });
    return String(signed?.downloadUrl || "").trim();
  } catch {
    return "";
  }
}

async function downloadViaBlob(href, name) {
  const res = await fetch(href, { mode: "cors" });
  if (!res.ok) throw new Error(`download_failed_${res.status}`);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  triggerNavigationDownload(objectUrl, name);
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1500);
}

/**
 * Download that works on mobile: prefer a same-origin signed URL with
 * Content-Disposition: attachment. Direct S3 fetch often fails CORS and
 * `window.open` only previews the file on phones.
 */
export async function downloadChatMedia(url, filename) {
  const href = String(url || "").trim();
  if (!href) return;
  const name = filename || filenameFromMediaUrl(href);
  const signed = await resolveSignedDownloadUrl(href, name);
  if (signed) {
    triggerNavigationDownload(signed, name);
    return;
  }
  try {
    await downloadViaBlob(href, name);
  } catch {
    triggerNavigationDownload(href, name);
  }
}
